export default __webpack_public_path__ + "static/media/hamburger.25dab705.svg";